import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadingStatus } from 'src/app/core/domain/events/state_provider';
import { Dietitian } from 'src/app/data/dietitian/domain/dietitian';
import { PatientGroup } from 'src/app/data/dietitian/domain/patient_group/patient_group';

import { PatientGroupListFacade } from './patient-group-list.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-patient-group-list',
  templateUrl: './patient-group-list.component.html',
  styleUrls: ['./patient-group-list.component.scss'],
  providers: [PatientGroupListFacade],
})
export class PatientGroupListComponent implements OnInit {
  @Input() selection: string | undefined;
  @Output() onSelect = new EventEmitter<PatientGroup | undefined>();
  @Output() onEdit = new EventEmitter<PatientGroup>();
  @Output() onDelete = new EventEmitter<PatientGroup>();
  currentDietitian?: Dietitian;
  patientGroups: PatientGroup[] = [];
  dietitianStateSub: Subscription;
  patientGroupEventsSub: Subscription;
  isLoading = true;
  error?: string;

  constructor(private facade: PatientGroupListFacade) {
    // do nothing
  }

  ngOnInit(): void {
    this.dietitianStateSub = this.facade.dietitianState$.subscribe((state) => {
      this.currentDietitian = state.entity;
      switch (state.loading) {
        case LoadingStatus.LOADING:
          this.isLoading = true;
          break;
        case LoadingStatus.ERROR:
          this.error = state.message;
          this.isLoading = false;
          break;
        case LoadingStatus.COMPLETE:
          this.loadPatientGroups();
          break;
      }
    });

    this.patientGroupEventsSub = this.facade.patientGroupEvents$.subscribe(
      () => {
        this.loadPatientGroups();
      },
    );
  }

  async loadPatientGroups() {
    this.isLoading = true;
    this.error = undefined;
    try {
      if (this.currentDietitian != null) {
        this.patientGroups = await this.facade.getDietitianPatientGroups(
          this.currentDietitian?.id.toString(),
        );
      } else {
        this.patientGroups = [];
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        this.error = error.message;
      }
    }
    this.isLoading = false;

    if (this.selection) {
      if (
        !this.patientGroups.some((pg) => pg.id.toString() == this.selection)
      ) {
        this.onSelect.emit();
      }
    }
  }

  ngOnDestroy(): void {
    this.dietitianStateSub?.unsubscribe();
    this.patientGroupEventsSub?.unsubscribe();
  }
}
